export default __webpack_public_path__ + "static/media/experience.dd660d06.md";